import { ReactElement } from 'react'
import { useCalls } from 'app/components/calls-list/useCalls'
import { CallsComponent } from 'app/components/calls-list/CallsComponent'

export default function Calls(): ReactElement {
  const hookData = useCalls()
  return <CallsComponent {...hookData} />
}
